import { UnauthedPageWithNavbar } from '../../../layout/UnauthedPageWithNavbar';
import MetaTags from '../../../util/MetaTags';
import { ApproachSection } from './ApproachSection';
import { HeroSection } from './HeroSection';
import { PerspectiveSurveySection } from './PerspectiveSurveySection';
import { useEffect } from 'react'

export const ProfessionalPausePage = () => {
  useEffect(() => {
  if (window.location.hash) {
    // allow scroll to form with 'perspective' hash in url
    const id = window.location.hash.slice(1);
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}, []);
  return (
    <UnauthedPageWithNavbar>
      <MetaTags
        title='Design what’s next with us | MovingWorlds.org'
        description='Individual professional participation is currently paused as we design our next phase of programming. Share your perspective to help shape what comes next.'
      />
      <HeroSection />
      <hr className='border-t border-gray-100' />
      <ApproachSection />
      <hr className='border-t border-gray-100' />
      <PerspectiveSurveySection />
    </UnauthedPageWithNavbar>
  );
};
